"use strict";
import format from "../../formatters/general";
import fetch from "../../util/fetch";
import LineItem, { validId } from "./line_item";
import { List, Map } from "immutable";
import { Flash } from "../../components/flash_messages";
import Api from "../../api/api";
import possibleNonCalculatedAlertIcon from "../ui/line_item_ignored_item_icon";
import lineItemsForCalculation from "../data/line_items_for_calculation";
import generalFormatter from "../../formatters/general";
import quickpayHelper from "../../helpers/quickpay";
import CarrierService from "../../services/carrier_service";
const carrierService = CarrierService.carrierService;
const didChange = (item, field, value) => {
  return parseFloat(item[field]) !== parseFloat(value);
};
const getTotal = (items) => {
  return items.reduce((memo, item) => {
    return memo + parseFloat(item.total);
  }, 0);
};
const LineItems = React.createClass({
  propTypes: {
    carrierInvoice: React.PropTypes.object.isRequired,
    load: React.PropTypes.object.isRequired,
    payment: React.PropTypes.object.isRequired,
    invoiceChangeComplete: React.PropTypes.func.isRequired
  },
  getInitialState: function() {
    return {
      loading: true,
      lineItems: List([]),
      lineItemsMatch: true,
      tmsUpdatedLoad: false,
      hasIgnoredLineItems: false
    };
  },
  componentWillMount: function() {
    this.getData(this.props);
  },
  componentWillReceiveProps: function(nextProps) {
    if (nextProps.carrierInvoice.id !== this.carrierInvoice().id) {
      this.getData(nextProps);
    }
  },
  // STATE
  totalChanged: function() {
    this.props.invoiceChangeComplete();
  },
  fetchLineItems: function(carrierInvoiceId) {
    return fetch(
      `/api/carrier_invoices/${carrierInvoiceId}/line_items`
    ).then((data) => data);
  },
  updateItem: function(item, field, value) {
    const idx = this.state.lineItems.indexOf(item);
    const items = this.state.lineItems;
    const newItem = Map(item).set(field, value).toJS();
    if (!validId(newItem.tms_line_item_type_id) || !didChange(item, field, value)) {
      return Promise.resolve();
    }
    return this.saveLineItem(newItem).then((data) => {
      var savedItem = data.tms_line_item;
      const newItems = items.update(idx, () => savedItem);
      this.setState({ lineItems: newItems });
      this.updateMatchData(data.match_results);
      this.totalChanged(newItems);
      return savedItem;
    });
  },
  saveLineItem: function(lineItem) {
    const id = lineItem.id || "";
    return fetch(
      `/api/carrier_invoices/${this.carrierInvoice().id}/line_items/${id}`,
      {
        method: validId(lineItem.id) ? "put" : "post",
        data: {
          tms_line_item: lineItem,
          creating_load: this.props.creatingLoad
        }
      }
    ).then((data) => data);
  },
  setStateAndCallback: function(items) {
    const calculationLineItems = lineItemsForCalculation(
      items,
      Api.Account.currentSettings().ignore_adjustment_line_items
    );
    const hasIgnoredLineItems = calculationLineItems.length !== items.length;
    const lineItemsList = List(calculationLineItems);
    this.setState({ lineItems: lineItemsList, hasIgnoredLineItems });
    this.totalChanged(lineItemsList);
    return lineItemsList;
  },
  getLineItems: function(carrierInvoiceId) {
    return this.fetchLineItems(carrierInvoiceId).then(
      (data) => {
        this.updateMatchData(data.match_results);
        return this.setStateAndCallback(data.tms_line_items);
      }
    );
  },
  addItem: function() {
    const newItem = { description: "", total: 0, new: true, id: "", tms_data: { rate_qualifier: "FR" } };
    const newItems = this.state.lineItems.push(newItem);
    this.setState({ lineItems: newItems });
  },
  deleteItem: function(item) {
    return fetch(
      `/api/carrier_invoices/${this.carrierInvoice().id}/line_items/${item.id}`,
      {
        method: "delete",
        data: { creating_load: this.props.creatingLoad }
      }
    ).then((data) => data);
  },
  updateMatchData: function(match_results) {
    this.setState({
      lineItemsMatch: match_results.line_items_match,
      tmsUpdatedLoad: match_results.tms_updated_load
    });
  },
  removeItem: function(item) {
    return () => {
      const lineItems = this.state.lineItems;
      const newItems = lineItems.delete(lineItems.indexOf(item));
      this.setState({ lineItems: newItems });
      this.totalChanged(newItems);
      if (validId(item.id)) {
        this.deleteItem(item).then((data) => {
          this.updateMatchData(data.match_results);
          Flash.success("Item deleted successfully!");
        }).catch(() => {
          Flash.error("There was a problem deleting the item");
          this.setState({ lineItems });
        });
      }
    };
  },
  getLineItemTypes: function() {
    return fetch("/api/line_item_types").then((data) => {
      if (this.isMounted()) {
        this.setState({
          lineItemTypes: data.line_item_types
        });
      }
      return data;
    });
  },
  getData: function(props) {
    Promise.all([
      this.getLineItemTypes(),
      this.getLineItems(props.carrierInvoice.id)
    ]).then(() => {
      this.setState({ loading: false });
    });
  },
  // RENDERING
  render: function() {
    let ignoreAdjustmentLineItems = Api.Account.currentSettings().ignore_adjustment_line_items;
    return /* @__PURE__ */ React.createElement("div", { className: "line-items" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Line items ", this.possibleAddItemLink())), this.possibleReplaceLineItemsDisplay(), possibleNonCalculatedAlertIcon(this.state.hasIgnoredLineItems, ignoreAdjustmentLineItems, true), this.noItems(), this.lineItems(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 small-offset-5 column\n                              possible-adjustments__factor-calculation" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "row\n                             possible-adjustments__starting-calculation-line"
      },
      /* @__PURE__ */ React.createElement("div", { className: "small-3 column\n                                  possible-adjustments__starting-amount" }, format.currency(this.props.payment.amount)),
      /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, "Payment Amount")
    ), /* @__PURE__ */ React.createElement("div", { className: "row\n                              possible-adjustments__starting-calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column\n                                  possible-adjustments__starting-amount" }, format.currency(this.lineItemTotal())), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, "Line Item Total")), this.possibleQuickpayBreakdown(), /* @__PURE__ */ React.createElement("div", { className: "row possible-adjustments__factor-total-line" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column\n                                  possible-adjustments__total-amount" }, format.currency(this.lineItemDiff())), /* @__PURE__ */ React.createElement("div", { className: "small-7 column possible-adjustments__total-label" }, "Difference")))))));
  },
  possibleAddItemLink: function() {
    if (!this.readOnly()) {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.addItem }, /* @__PURE__ */ React.createElement("i", { className: "fi-plus" }));
    }
  },
  readOnly: function() {
    return this.carrierInvoice().state == "approved" || this.carrierInvoice().state == "abandoned" || !this.props.creatingLoad && Api.Account.shouldShowReadOnlyLineItems();
  },
  shouldShowReplaceLineItemsDisplay: function() {
    if (this.readOnly() || !this.loadHasLineItems()) {
      return false;
    }
    return (!this.state.lineItemsMatch || this.state.tmsUpdatedLoad) && !this.props.creatingLoad;
  },
  loadHasLineItems: function() {
    return !_.isEmpty(this.props.load.load.line_items);
  },
  possibleReplaceLineItemsDisplay: function() {
    if (this.shouldShowReplaceLineItemsDisplay()) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution line-items__replace-alert" }, this.replaceLineItemsMessage(), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.replaceLineItems,
          className: "line-items__replace-button"
        },
        "Replace Line Items"
      )));
    }
  },
  carrierInvoice: function() {
    return this.props.carrierInvoice;
  },
  carrier: function() {
    return carrierService.getCarrierOrUnknown(this.carrierInvoice().carrier_id);
  },
  hasQuickpayAdjustment: function() {
    return quickpayHelper.hasQuickpayAdjustment(this.carrierInvoice(), this.carrier());
  },
  quickpayDiscountPercentage: function() {
    return quickpayHelper.quickpayPercentage(this.carrier());
  },
  quickpayDiscountAmount: function() {
    return quickpayHelper.quickpayDiscountAmount(this.invoiceAmount(), this.carrier());
  },
  invoiceAmount: function() {
    var amount = parseFloat(this.carrierInvoice().amountToPay || this.carrierInvoice().source_invoice_amount);
    return isNaN(amount) ? 0 : amount;
  },
  possibleQuickpayBreakdown: function() {
    if (this.carrierInvoice().quickpay_disposition == "not_applied_to_invoice" && this.hasQuickpayAdjustment()) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column possible-adjustments__calculation-line" }, /* @__PURE__ */ React.createElement("div", { className: "operation" }, "-"), generalFormatter.currency(this.quickpayDiscountAmount())), /* @__PURE__ */ React.createElement("div", { className: "small-7 column" }, quickpayHelper.quickpayDiscountAmountUsed(this.invoiceAmount(), this.carrier()), " Quickpay Discount"));
    } else {
      return null;
    }
  },
  replaceLineItemsMessage: function() {
    if (this.state.tmsUpdatedLoad) {
      return "Line items for this load have been modified in the TMS.";
    } else if (!this.state.lineItemsMatch) {
      return "Line items do not match line items from load.";
    }
  },
  replaceLineItems: function() {
    this.replaceItems().then((data) => {
      this.updateMatchData(data.match_results);
      this.setStateAndCallback(data.tms_line_items);
      Flash.success("Line Items Replaced Successfully!");
    });
  },
  replaceItems: function() {
    return fetch(
      `/api/carrier_invoices/${this.carrierInvoice().id}/replace_line_items`,
      {
        method: "post"
      }
    ).then((data) => data);
  },
  lineItemDiffRow: function() {
    let msg;
    const diff = this.lineItemDiff();
    if (diff === 0) {
      msg = "Line items match the invoice amount";
    } else if (diff < 0) {
      msg = format.currency(-diff) + " less than the payment amount";
    } else {
      msg = format.currency(diff) + " more than the payment amount";
    }
    return msg;
  },
  lineItemTotal: function() {
    return getTotal(this.state.lineItems);
  },
  lineItemDiff: function() {
    let lineItemTotal = this.lineItemTotal() - this.props.payment.amount;
    if (this.hasQuickpayAdjustment && this.carrierInvoice().quickpay_disposition == "not_applied_to_invoice") {
      lineItemTotal -= this.quickpayDiscountAmount();
    }
    return lineItemTotal;
  },
  noItems: function() {
    if (this.state.lineItems.isEmpty()) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box secondary" }, "No line items."));
    }
  },
  lineItems: function() {
    return this.state.lineItems.map(this.lineItem);
  },
  lineItem: function(lineItem, idx) {
    if (!this.state.loading) {
      return /* @__PURE__ */ React.createElement(
        LineItem,
        {
          readOnly: this.readOnly(),
          creatingLoad: this.props.creatingLoad,
          lineItem,
          updateItem: this.updateItem,
          removeItem: this.removeItem,
          key: "line-item-" + (!validId(lineItem.id) ? `new-${idx}` : lineItem.id),
          lineItemTypes: this.state.lineItemTypes
        }
      );
    }
  }
});
export default LineItems;
